import React, { useEffect, useState } from 'react'
import { Input } from 'antd'
import './CommentInput.scss'

const CommentInput = ({
  text,
  onChange,
  disabled = false,
  placeholder = 'Write a comment...'
}) => {
  const [value, setValue] = useState('')

  const [isFirstValue, setIsFirstValue] = useState(true)

  useEffect(() => {
    setValue(text)
  }, [text])

  useEffect(() => {
    if (isFirstValue) {
      setIsFirstValue(false)
      return
    }
    onChange && onChange(value)
  }, [value])

  const handleChange = e => {
    const text = e.target.value
    setValue(text)
  }

  return (
    <div className="comment-input">
      <div className="comment-input-header">
        <label>Prompt</label>
      </div>
        <Input.TextArea
          value={value}
          onChange={handleChange}
          readOnly={disabled}
          autosize={{ minRows: 2, maxRows: 6 }}
          placeholder={placeholder}
        />
    </div>
  )
}

export default CommentInput
